// メディアライブラリのモックデータ

export type MediaItem = {
  id: string;
  name: string;
  type: "image" | "document" | "video";
  size: string;
  date: string;
  gradient: string;
  ext: string;
};

const gradients = [
  "linear-gradient(135deg, #2563eb, #60a5fa)",
  "linear-gradient(135deg, #16a34a, #4ade80)",
  "linear-gradient(135deg, #ec4899, #f9a8d4)",
  "linear-gradient(135deg, #f59e0b, #fcd34d)",
  "linear-gradient(135deg, #8b5cf6, #c4b5fd)",
  "linear-gradient(135deg, #06b6d4, #67e8f9)",
  "linear-gradient(135deg, #ef4444, #fca5a5)",
  "linear-gradient(135deg, #0f172a, #475569)",
  "linear-gradient(135deg, #14b8a6, #5eead4)",
  "linear-gradient(135deg, #d97706, #fbbf24)",
  "linear-gradient(135deg, #6366f1, #a5b4fc)",
  "linear-gradient(135deg, #db2777, #f472b6)",
];

const fileNames = [
  "hero-banner.jpg",
  "service-thumbnail-01.png",
  "blog-cover-ai.webp",
  "logo-primary.svg",
  "team-photo.jpg",
  "office-interior.jpg",
  "case-study-01.pdf",
  "campaign-2026.png",
  "product-demo.mp4",
  "icon-set.svg",
  "blog-cover-seo.webp",
  "white-paper.pdf",
];

export const mediaItems: MediaItem[] = fileNames.map((name, i) => {
  const ext = name.split(".").pop()!;
  return {
    id: `m${i}`,
    name,
    type: ext === "pdf" ? "document" : ext === "mp4" ? "video" : "image",
    size: ["1.2 MB", "324 KB", "892 KB", "12 KB", "2.4 MB", "1.8 MB", "654 KB"][i % 7],
    date: ["2026-06-07", "2026-06-05", "2026-06-02", "2026-05-30", "2026-05-25"][i % 5],
    gradient: gradients[i % gradients.length],
    ext: ext.toUpperCase(),
  };
});

export const folders = [
  { label: "すべて", value: "all", count: 246 },
  { label: "ブログ画像", value: "blog", count: 84 },
  { label: "サービス紹介", value: "service", count: 32 },
  { label: "バナー", value: "banner", count: 18 },
  { label: "ロゴ・素材", value: "logo", count: 12 },
  { label: "ドキュメント", value: "doc", count: 24 },
  { label: "動画", value: "video", count: 6 },
  { label: "アーカイブ", value: "archive", count: 70 },
];
